function el<T extends Element>(id: string) {
  return document.querySelector<T>(`#${id}`)!
}

export const ui = {
  pane: el<HTMLDivElement>('pane'),
  canvas: el<HTMLCanvasElement>('graph'),
  tube: el<HTMLCanvasElement>('tube'),
  hover: el<HTMLCanvasElement>('hover'),
  svg: el<SVGSVGElement>('overlay-svg'),
  marks: el<SVGGElement>('overlay-marks'),
  walkRows: el<SVGGElement>('walk-rows'),
  stripLocator: el<SVGGElement>('strip-locator'),
  strip: el<HTMLElement>('walk-strip'),
  stripSvg: el<SVGSVGElement>('strip-svg'),
  stripBars: el<SVGGElement>('strip-bars'),
  stripMarks: el<SVGGElement>('strip-marks'),
  stripLabels: el<SVGGElement>('strip-labels'),
  stripTip: el<HTMLDivElement>('strip-tip'),
  stripKey: el<HTMLDivElement>('strip-key'),
  html: el<HTMLDivElement>('overlay-html'),
  facets: el<HTMLDivElement>('facets'),
  legends: el<HTMLDivElement>('legends'),
  info: el<HTMLDivElement>('info'),
  details: el<HTMLElement>('details'),
  announce: el<HTMLDivElement>('announce'),
  loading: el<HTMLDivElement>('loading'),
  loadingText: el<HTMLSpanElement>('loading-text'),
  loadingTime: el<HTMLSpanElement>('loading-time'),
  cancel: el<HTMLButtonElement>('cancel'),
  toast: el<HTMLDivElement>('toast'),
  toastText: el<HTMLSpanElement>('toast-text'),
  toastActions: el<HTMLSpanElement>('toast-actions'),
  toastClose: el<HTMLButtonElement>('toast-close'),
  back: el<HTMLButtonElement>('back'),
  caption: el<HTMLDivElement>('caption'),
  hint: el<HTMLDivElement>('hint'),
  hintClose: el<HTMLButtonElement>('hint-close'),
  guideDialog: el<HTMLDialogElement>('guide-dialog'),
  aboutDialog: el<HTMLDialogElement>('about-dialog'),
  layoutDialog: el<HTMLDialogElement>('layout-dialog'),
  layoutReset: el<HTMLButtonElement>('layout-reset'),
  highlightDialog: el<HTMLDialogElement>('highlight-dialog'),
  highlightRows: el<HTMLDivElement>('highlight-rows'),
  zoomIn: el<HTMLButtonElement>('zoom-in'),
  zoomOut: el<HTMLButtonElement>('zoom-out'),
  zoomFit: el<HTMLButtonElement>('zoom-fit'),
  empty: el<HTMLDivElement>('empty'),
  stats: el<HTMLSpanElement>('stats'),
  menus: el<HTMLElement>('menus'),
  findForm: el<HTMLFormElement>('find-form'),
  find: el<HTMLInputElement>('find'),
  findList: el<HTMLDataListElement>('find-list'),
  locateForm: el<HTMLFormElement>('locate-form'),
  locate: el<HTMLInputElement>('locate'),
  locateBack: el<HTMLButtonElement>('locate-back'),
  locateForward: el<HTMLButtonElement>('locate-forward'),
  file: el<HTMLInputElement>('file'),
  emptyOpen: el<HTMLButtonElement>('empty-open'),
  openDialog: el<HTMLDialogElement>('open-dialog'),
  openFile: el<HTMLButtonElement>('open-file'),
  openGbz: el<HTMLButtonElement>('open-gbz'),
  recent: el<HTMLElement>('recent'),
  recentList: el<HTMLUListElement>('recent-list'),
  url: el<HTMLInputElement>('url'),
  gbzDialog: el<HTMLDialogElement>('gbz-dialog'),
  gbzDb: el<HTMLInputElement>('gbz-db'),
  gbzIndex: el<HTMLInputElement>('gbz-index'),
  gbzIndexField: el<HTMLLabelElement>('gbz-index-field'),
  gbzStatus: el<HTMLParagraphElement>('gbz-status'),
  gbzRef: el<HTMLInputElement>('gbz-ref'),
  gbzRefs: el<HTMLDataListElement>('gbz-refs'),
  gbzRegion: el<HTMLInputElement>('gbz-region'),
  gbzHaplotypes: el<HTMLInputElement>('gbz-haplotypes'),
  referenceDialog: el<HTMLDialogElement>('reference-dialog'),
  referenceStatus: el<HTMLParagraphElement>('reference-status'),
  genomeSearch: el<HTMLInputElement>('genome-search'),
  genomeResults: el<HTMLUListElement>('genome-results'),
  genomeHint: el<HTMLParagraphElement>('genome-hint'),
  referenceChosen: el<HTMLElement>('reference-chosen'),
  referenceGenesRow: el<HTMLLabelElement>('reference-genes-row'),
  referenceGenes: el<HTMLSelectElement>('reference-genes'),
  referenceContigs: el<HTMLDivElement>('reference-contigs'),
  referenceRememberRow: el<HTMLLabelElement>('reference-remember-row'),
  referenceRemember: el<HTMLInputElement>('reference-remember'),
  referenceRememberText: el<HTMLSpanElement>('reference-remember-text'),
  referenceHubs: el<HTMLDetailsElement>('reference-hubs'),
  hubList: el<HTMLUListElement>('hub-list'),
  hubUrl: el<HTMLInputElement>('hub-url'),
  hubAdd: el<HTMLButtonElement>('hub-add'),
  referenceApply: el<HTMLButtonElement>('reference-apply'),
}
